export default {
  review_question_1: 'I found the service at Luxity was exceptional.',
  review_question_2: 'I would recommend Luxity to a friend.',
  comment: 'Do you have any other comments you would like us to know?',
};
